function HeaderAbout() {
    return (
        <div className="header-about text-center">
            <div className="overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12 header-content">
                        <div>
                            <h1>About Us</h1>
                            <span>Home - About Page</span>
                        </div>
                    </div>
                    <div className="col-12 top-header-content">
                        <div>
                            <button className="btn-start">
                                <i className="fas fa-play"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderAbout;